import * as React from "react";
const SvgPlug = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 10.0 10.0", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 10, height: 10, fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgPlug;
